import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Loader from '../Search/Loader'
import Pagination from './Pagination'
import Table from './Table/Table'

import './Results.css'

class Results extends Component {
    hitsPerPage = 100;
    state = {
        resultPages: {},
        listData: [],
        currentPage: 1,
        totalRows: 0,
        loading: false,
        totalLoading: false,
    }

    componentDidUpdate(prevProps, prevState) {
        // Update table in case of new query
        if (this.props.activeQuery !== prevProps.activeQuery) {
            this.handleMakeSearchQuery(this.props.activeQuery)
        }
    }

    updateIfEqual = (stateVal, qVal, newState) => {
        if (stateVal === qVal) {
            this.setState(newState)
        } else {
            console.log("Expired API call");
        }
    }


    // Splits an array of items into chunks of size chunkSize (the last chunk might be smaller)
    // Returns an array of arrays
    splitList = (list, chunkSize) => {
        const output = [];
        for (let i = 0; i*chunkSize<list.length; i+=1) {
            output.push(list.slice(i*chunkSize, Math.min((i+1)*chunkSize, list.length)));
        }
        return output;
    }

    handleMakeSearchQuery = (apiUrl) => {
        console.log(apiUrl);
        if (apiUrl === this.state.activeQuery) return this.setState({currentPage: 1, listData: this.state.resultPages[1]})
        this.setState({loading: true, totalLoading: true, error: false, activeQuery: apiUrl})
        console.log(this.props.hostname + apiUrl);
        fetch(this.props.hostname + apiUrl)
            .then(res => res.json())
            .then(data => {
                const resultPages = this.splitList(data, 100).reduce((acc, cur, i) => {
                    acc[i+1] = cur;
                    return acc;
                }, {});
                console.log(data);
                this.updateIfEqual(
                    this.state.activeQuery,
                    apiUrl,
                    {
                        loading: false,
                        listData: resultPages[1] ? resultPages[1] : [],
                        resultPages: resultPages,
                        currentPage: 1
                    }
                )
            }).catch((err) => {
                console.error("An error has occurred!", err);
                this.setState({
                    error: true,
                    loading: false
                })
            });
        fetch(this.props.hostname + apiUrl + '&getTotalRows=true')
            .then(res => res.json())
            .then(data => {
                this.updateIfEqual(
                    this.state.activeQuery,
                    apiUrl,
                    {
                        totalLoading: false,
                        totalRows: data.rowCount
                    }
                )
            }).catch((err) => {
                console.error("An error has occurred!", err);
                this.setState({
                    error: true,
                    totalLoading: false
                })
            });
    }


    getTotalPages = () => Math.floor(this.state.totalRows/this.hitsPerPage) + 1

    handleLoadPage = (pageNo) => {
        if (this.state.resultPages[pageNo]) {
            return this.setState({listData: this.state.resultPages[pageNo], currentPage: pageNo})
        }
        if (Math.ceil(this.state.currentPage/10) === Math.ceil(pageNo/10)) return this.setState({currentPage: pageNo})
        this.setState({
            loading: true,
            currentPage: pageNo
        });
            fetch(this.props.hostname + this.state.activeQuery + '&offset=' + ((Math.ceil((pageNo)/10 - 1)*10)*this.hitsPerPage))
            .then(res => res.json())
            .then(data => {
                const newResultPages = this.splitList(data, 100).reduce((acc, cur, i) => {
                    acc[i+1+(Math.ceil((pageNo)/10 - 1)*10)] = cur;
                    return acc
                }, {...this.state.resultPages});
                this.updateIfEqual(
                    Math.ceil(this.state.currentPage/10),
                    Math.ceil(pageNo/10),
                    {loading: false, listData: newResultPages[this.state.currentPage], resultPages: newResultPages}
                )
                console.log(this.state.resultPages);
            })
    }

    render() {
        const resultsClasses = ['results-wrapper']
            .concat(this.state.loading ? 'greyout' : null)
            .join(' ');

        return (
            <div className={resultsClasses}>
                {
                    this.state.totalLoading ?
                    <Loader loading={this.state.totalLoading}/> :
                        this.state.listData && this.state.listData.length ?
                            <Pagination
                                firstItemIndex={this.state.firstItemIndex}
                                currentPage={this.state.currentPage}
                                totalPages={this.getTotalPages()}
                                onChangePage={this.handleLoadPage}
                                inactive={this.state.loading}
                                /> :
                            null
                }
                {
                    (this.state.listData && this.state.listData.length) ?
                        <Table
                            showCSVModal={this.props.openDownloadModal}
                            totalLoading={this.state.totalLoading}
                            getTotalPages={this.getTotalPages}
                            loading={this.state.loading}
                            listData={this.state.listData}
                            totalRows={this.state.totalRows}
                            /> :
                        null
                }
                {
                    this.state.loading ?
                        <Loader loading={this.state.loading} />:
                        null
                }
            </div>
        )
    }
}

Results.propTypes = {
    activeQuery: PropTypes.string.isRequired
}


export default Results;



// WEBPACK FOOTER //
// ./src/Components/Results.js